'use client'

import { howItWorks } from '@/app/(home)/data'
import { Section } from '@/components'
import { usePartner } from '@/hooks'
import Image from 'next/image'

const HowItWorks = () => {
  const { getStoredPartner } = usePartner()

  const storedPartner = getStoredPartner()
  const howItWorksBData = howItWorks(storedPartner)

  return (
    <Section className="bg-gray-100 px-6">
      <div className="flex flex-col-reverse gap-16 lg:flex-row">
        <div className="basis-1/4">
          <Image
            className="rounded-2xl"
            src={`/img/pages/arrendamento-de-usinas-intro.jpg`}
            alt="Grupo BC Energia"
            width={1024}
            height={2014}
          />
        </div>
        <div className="basis-3/4" id="como-funciona">
          <h2 className="mb-6 text-2xl uppercase text-teal-900">
            Como funciona o Consórcio BC Energia?
          </h2>
          <div className="flex flex-col gap-6">
            {howItWorksBData.map((item, i) => (
              <div key={i} className="flex gap-6">
                <h6 className="mt-1 h-9 w-9 flex-none items-center justify-center rounded-full border border-teal-600 p-[0.2rem] text-center text-lg font-bold text-teal-600">
                  {i + 1}
                </h6>
                <div>
                  <h4 className="text-xl text-teal-600">{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default HowItWorks
